export const faqs = [
  {
    id: 1,
    question: "1. How does a wind speed indicator improve crane safety?",
    answer: "<p>A wind speed indicator gives crane operators real-time wind readings and can trigger alarms when preset limits are reached. This helps operators respond to changing conditions before wind affects lifting safety.</p>",
  },
  {
    id: 2,
    question: "2. What wind speed should I set for a crane wind alarm?",
    answer: "<p>The correct alarm limit depends on the crane manufacturer’s recommendations, operating conditions, and lift requirements. Operators should follow the crane’s manuals and site safety procedures rather than using one universal wind speed.</p>",
  },
  {
    id: 3,
    question: "3. What can the Trimble GS820 display monitor on a mobile crane?",
    answer: "<p>The Trimble GS820 can monitor multiple crane sensors, including load cells, load pins, wind speed, angle, length, anti-two-block systems, and rope payout, while displaying data and alarms in real time.</p>",
  },
  {
    id: 4,
    question: "4. What is the 3-3-3 rule for cranes?",
    answer: "<p>The 3-3-3 rule is a crane safety practice that may require keeping personnel three meters away, lifting the load about 30 centimeters, and checking its stability for 30 seconds before continuing the lift.</p>",
  },
  {
    id: 5,
    question: "5. Can a crane lift 70 tons?",
    answer: "<p>Yes, a crane can lift 70 tons if its rated capacity and load chart allow it for the specific lift. Capacity also depends on load radius, boom configuration, ground conditions, and rigging.</p>",
  },
  {
    id: 6,
    question: "6. What does a Rated Capacity Indicator do on a mobile crane?",
    answer: "<p>A Rated Capacity Indicator monitors load, radius, boom angle, and other crane conditions, helping operators recognize approaching overloads and operate within the crane’s rated capacity.</p>",
  },
  {
    id: 7,
    question: "7. How does a crane overload protection system work?",
    answer: "<p>An overload protection system monitors the crane’s lifting conditions against rated capacity limits, providing warnings when limits are approached and, depending on configuration, restricting functions that could increase loading.</p>",
  },
  {
    id: 8,
    question: "8. Why is a crane load chart important for safe lifting?",
    answer: "<p>A crane load chart shows permitted lifting capacities for different configurations, boom lengths, and load radii. Operators use it to determine whether planned lifts remain within rated limits.</p>",
  },
  {
    id: 9,
    question: "9. What are the main features of Greer system products for mobile cranes?",
    answer: "<p>Greer systems provide real-time monitoring of load, radius, boom angle, capacity, and configuration, with overload warnings, operator-settable alarms, obstacle avoidance features, and fast crane calibration capabilities.</p>",
  },
  {
    id: 10,
    question: "10. What are the essential safety systems for mobile cranes?",
    answer: "<p>Essential systems include Rated Capacity Indicators, overload protection, anti-two-block devices, boom angle monitoring, load monitoring, wind speed indicators, and work area limiters to support safer crane operations.</p>",
  },
  {
    id: 11,
    question: "11. How does a wireless crane camera improve safety during blind lifts?",
    answer: "<p>A wireless crane camera gives operators a direct view of loads and surrounding areas that are difficult to see, improving situational awareness during blind and distant lifting operations.</p>",
  },
  {
    id: 12,
    question: "12. Where can HoistCam wireless cameras be mounted on cranes?",
    answer: "<p>HoistCam cameras can be mounted on hook blocks, boom tips, trolleys, or other suitable surfaces using magnetic mounts and safety lanyards, depending on the crane and application.</p>",
  },
  {
    id: 13,
    question: "13. Can wireless crane cameras be used in outdoor or harsh conditions?",
    answer: "<p>Yes, compatible HoistCam models feature rugged, weatherproof construction and infrared illumination for nighttime viewing, making them suitable for construction, industrial, marine, and other demanding environments.</p>",
  },
  {
    id: 14,
    question: "14. How far can a wireless crane camera transmit video?",
    answer: "<p>Wireless crane camera range varies by model and site conditions. Some HoistCam systems provide transmission distances of up to 2,000 feet, helping operators monitor remote lifting areas.</p>",
  },
  {
    id: 15,
    question: "15. Can crane cameras work at night?",
    answer: "<p>Yes, suitable crane camera systems can support nighttime operations using infrared illumination, allowing operators to view loads and surrounding areas when natural lighting is limited or unavailable.</p>",
  },
  {
    id: 16,
    question: "16. Can an old crane LMI system be upgraded without replacing all the sensors?",
    answer: "<p>Yes, certain retrofit systems can reuse existing sensors and components. For example, qSCALE maestro is designed to upgrade compatible PAT systems while reducing installation time and avoiding recalibration.</p>",
  },
  {
    id: 17,
    question: "17. How often does a mobile crane LMI need calibration?",
    answer: "<p>LMI calibration requirements depend on the crane, system, manufacturer specifications, and applicable regulations. Calibration should be performed by qualified personnel whenever required or after relevant system changes or repairs.</p>",
  },
  {
    id: 18,
    question: "18. Why is my crane load moment indicator showing the wrong load?",
    answer: "<p>Incorrect load readings can result from boom length, angle, pressure sensor readings, crane configuration, rigging, or calibration issues. These inputs should be checked before replacing sensors or components.</p>",
  },
  {
    id: 19,
    question: "19. What is CAN bus technology used for in mobile cranes?",
    answer: "<p>CAN bus technology allows crane sensors and electronic control components to communicate efficiently, helping systems collect and share operating information between sensors, controllers, displays, and other devices.</p>",
  },
  {
    id: 20,
    question: "20. Why does a crane need boom angle and length sensors?",
    answer: "<p>Boom angle and length sensors help determine the crane’s operating geometry, allowing control systems to calculate load conditions and provide information needed for safer lifting within permitted operating limits.</p>",
  },
  {
    id: 21,
    question: "21. How does a power line proximity warning system work?",
    answer: "<p>A proximity warning system detects the electrostatic field around energized AC power lines and alerts equipment operators through audible and visual signals when machinery approaches the configured warning zone.</p>",
  },
  {
    id: 22,
    question: "22. How close can construction equipment get to overhead power lines?",
    answer: "<p>Required clearance depends on line voltage and applicable regulations. OSHA generally requires 20 feet unless another permitted option or applicable minimum approach distance provides the required protection.</p>",
  },
  {
    id: 23,
    question: "23. What types of equipment can use power line proximity alarms?",
    answer: "<p>Power line proximity alarms can be installed on cranes, excavators, aerial platforms, boom trucks, concrete pumps, drill rigs, dump trucks, fire apparatus, and many other boom-equipped machines.</p>",
  },
  {
    id: 24,
    question: "24. Can a power line proximity alarm stop a crane from moving?",
    answer: "<p>Some proximity systems can activate an external relay connected to equipment controls, allowing configured function lockout to restrict movement toward a detected electrical hazard.</p>",
  },
  {
    id: 25,
    question: "25. Do power line proximity alarms replace safe clearance requirements?",
    answer: "<p>No. A proximity alarm is an additional operational safeguard, not a substitute for required clearances, planning, deenergization, grounding, or other protective measures specified by applicable safety regulations.</p>",
  },
  {
    id: 26,
    question: "26. What sensors are used in mobile cranes?",
    answer: "<p>Mobile cranes commonly use boom length, boom angle, pressure, load, wind speed, and anti-two-block sensors to provide operating data for monitoring and control systems.</p>",
  },
  {
    id: 27,
    question: "27. What does a cable reel do on a crane?",
    answer: "<p>A crane cable reel houses length and angle sensing components while routing the Anti-Two-Block signal toward the boom tip, helping monitoring systems track boom movement and position.</p>",
  },
  {
    id: 28,
    question: "28. What is a CAN bus sensor used for on construction equipment?",
    answer: "<p>CAN bus sensors transmit measurement data between electronic components, allowing crane monitoring systems to communicate information such as boom angle, length, pressure, and other operating conditions.</p>",
  },
  {
    id: 29,
    question: "29. What causes a crane pressure sensor to fail?",
    answer: "<p>Crane pressure sensors can be affected by electrical faults, damaged wiring, contamination, excessive pressure, temperature extremes, or normal component wear, potentially causing inaccurate readings or system warnings.</p>",
  },
  {
    id: 30,
    question: "30. How often should crane sensors be checked?",
    answer: "<p>Crane sensors should be inspected according to the equipment manufacturer’s maintenance requirements and whenever readings appear abnormal, components are repaired, or the monitoring system requires calibration or troubleshooting.</p>",
  },
];

export default faqs;